export default __webpack_public_path__ + "static/media/X.610d87b2.svg";